import React, { useState, useEffect } from 'react'
import System from 'src/helper/system';
import Order from '@system/config/order';
import Constants from 'src/helper/Constants';
import OrderDetailByShipment from './OrderDetailByShipment';
import OrderDetailByLineItem from './OrderDetailByLineItem';
import { useOrderStore } from 'src/hooks/order';

let c = System.getParams();

const OrderDetailTabsData = () => {
    const { OrderDetailTabList } = Constants
    const OrderTabType = System.getParams().tab || OrderDetailTabList.BY_SHIPMENT.param_value;
    const OrderTabTypeName = OrderTabType === OrderDetailTabList.BY_SHIPMENT.param_value ? OrderTabType : OrderDetailTabList.BY_LINE_ITEMS.param_value 
    const [selectedTab, setSelectedTab] = useState()
    const [{ }, { }, { remove_all_selected_fields }] = useOrderStore();
    useEffect(() => {
        setSelectedTab(OrderTabType !== undefined ? OrderTabType : OrderDetailTabList.BY_SHIPMENT.param_value)
      }, [OrderTabType])

      const getActiveClass = (singleElement) => {
        if (OrderDetailTabList[selectedTab]?.param_value === singleElement.param_value) {
            return 'active'
        }
        return ''
    };

    const getTabLink = (singleElement) => {
        setSelectedTab(singleElement.param_value)
        return Order.getOrderDetailTabsListRouteURL({
            ...c,
            ['tab']: singleElement.param_value
        });
    };

    const switchTab = async (url) => {
        history.pushState('', '', url);
    };

    return (
        <>
            <ul className="bs5 nav nav-tabs m-t-20">
                {Object.entries(OrderDetailTabList).map((v) => (
                    <li className={'maxw-auto'} key={v[1].name}>
                        <a className={'text-uppercase font-bold ' + getActiveClass(v[1])}
                            href={void (0)}
                            onClick={async () => {
                                await switchTab(getTabLink(v[1]), v[1])
                                await remove_all_selected_fields()
                            }}
                        >
                            <span>{v[1].name}</span>
                        </a>
                    </li>
                ))}
            </ul>

            <div>
                {OrderTabTypeName ===  OrderDetailTabList.BY_SHIPMENT.param_value && <OrderDetailByShipment />}
                {OrderTabTypeName ===  OrderDetailTabList.BY_LINE_ITEMS.param_value && <OrderDetailByLineItem />}
            </div>
        </>
    )
}

export default OrderDetailTabsData